import "./agGridSetup";
import "./App.css";
import { HashRouter as Router, Routes, Route } from "react-router-dom";
import { UserProvider } from './components/UserContext';
import PrivateRoute, { AdminRoute } from './components/PrivateRoute';
import ErrorBoundary from './components/ErrorBoundary'; // Error handling
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// import LoginNavideño from "./components/LoginNavideño";
import Login from "./components/Login";
import NotFound from './components/NotFound'; // 404 Page
// colaborador
import Init from "./pages/Init";
import Recibos from './pages/RecibosView';
import Beneficios from './pages/Beneficios_backup'
// capacitaciones
import CargarCapacitaciones from "./pages/CargarCapacitaciones";
import CapacitacionesAdmin from "./components/CapacitacionesAdmin";
import VerCapacitaciones from "./components/VerCapacitaciones";
import ListaModulos from "./components/ListaModulos";
import VerModulo from "./components/VerModulo";
import CargarEvaluacion from "./components/CargarEvaluacion";
import ResumenCapacitaciones from "./pages/ResumenCapacitaciones";
// procedimientos
import Procedimientos from "./pages/Procedimientos_backup";
import AdminProcedimientos from "./pages/admin/AdminProcedimientos";
import AdminUsuariosGestion from "./pages/admin/AdminUsuarios";
// informes
// import InformesList from './components/InformesList'
import InformesPendientes from "./components/InformesPendientes";
import DescargoForm from './components/DescargoForm'
import RecuperarContrasena from "./components/RecuperarContraseña";
import InformesDevueltos from "./components/InformesDevueltos";
import InformesConfirmados from "./components/InformesConfirmados";
// administrador
import AdminInit from './modules/administrador/pages/initG';
import DownloadsReport from './modules/administrador/pages/DownloadsReport';
import AdminUsuarios  from './modules/administrador/pages/AdminUsuarios';
import ReclamosAdmin from './modules/administrador/pages/ReclamosAdmin';
import AdminLayout from './modules/administrador/pages/AdminLayout';
import AdminDocuments from "./modules/administrador/pages/AdminDocuments";
import DamageComparison from "./modules/administrador/components/DamageComparison";
import TallesAdminView from "./modules/administrador/pages/TallesAdminView";
import AdminBeneficios from "./modules/administrador/pages/AdminBeneficios_clean";
import ActivityDashboard from "./modules/administrador/pages/ActivityDashboard";
import ActivityDashboardMejorado from "./modules/administrador/pages/ActivityDashboardMejorado";
import CargaRecibos from "./modules/administrador/components/CargaRecibos";
//
import SubirDiagrama from "./components/SubirDiagrama";
import MisDiagramas from "./components/MisDiagramas";
import AdminDiagramas from "./modules/administrador/pages/AdminDiagramas";
// informes
import InformesInicio from "./modules/inspeccion/components/InformesInicio";
import "bootstrap/dist/css/bootstrap.min.css";
import DiagramacionMensual from "./modules/administrador/components/DiagramacionMensual";
import HelpChatWidget from "./components/HelpChatWidget"; // Widget de ayuda con IA
import AdminAIKnowledge from "./modules/administrador/pages/AdminAIKnowledge"; // Gestión IA
// Flota
import FlotaResumen from "./modules/administrador/pages/flota/FlotaResumen";
import FlotaUnidades from "./modules/administrador/pages/flota/FlotaUnidades";
import FlotaDetalle from "./modules/administrador/pages/flota/FlotaDetalle";
import FlotaActividad from "./modules/administrador/pages/flota/FlotaActividad";
import FlotaAlertas from "./modules/administrador/pages/flota/FlotaAlertas";
// Políticas y Visión
import AdminPoliticas from "./modules/administrador/pages/AdminPoliticas";

function App() {

  const token = localStorage.getItem('token');
  const user = JSON.parse(localStorage.getItem('user'));

  return (
    <ErrorBoundary>
      <UserProvider value={{ token, user }}>
        <Router>
          <Routes>
            {/* Rutas públicas */}
            <Route path="/" element={<Login />} />
            <Route path="/recuperar-contrasena" element={<RecuperarContrasena />} />
            
            {/* Rutas protegidas - Colaborador */}
            <Route path="/home" element={<PrivateRoute><Init /></PrivateRoute>} />
            <Route path="/home/recibos" element={<PrivateRoute><Recibos /></PrivateRoute>} />
            <Route path="/home/beneficios" element={<PrivateRoute><Beneficios /></PrivateRoute>} />
            <Route path="/home/cargar-capacitaciones" element={<PrivateRoute><CapacitacionesAdmin /></PrivateRoute>} />
            <Route path="/home/ver-capacitaciones" element={<PrivateRoute><VerCapacitaciones usuario={user} /></PrivateRoute>} />
            <Route path="/home/modulos/:categoria_id" element={<PrivateRoute><ListaModulos usuario={user} /></PrivateRoute>} />
            <Route path="/home/ver-modulo/:id" element={<PrivateRoute><VerModulo usuario={user} /></PrivateRoute>} />
            <Route path="/home/informes" element={<PrivateRoute><InformesInicio /></PrivateRoute>} />
            <Route path="/home/ver-informes-encargado" element={<PrivateRoute><InformesPendientes token={token} /></PrivateRoute>} />
            <Route path="/home/ver-informes-devueltos" element={<PrivateRoute><InformesDevueltos token={token} /></PrivateRoute>} />
            <Route path="/home/ver-informes-confirmados" element={<PrivateRoute><InformesConfirmados token={token} /></PrivateRoute>} />
            <Route path="/home/descargo/:id" element={<PrivateRoute><DescargoForm userData={user} /></PrivateRoute>} />
            <Route path="/home/subir-diagrama" element={<PrivateRoute><SubirDiagrama usuario={user} /></PrivateRoute>} />
            <Route path="/home/mis-diagramas" element={<PrivateRoute><MisDiagramas key={user?.Legajo} usuario={user} /></PrivateRoute>} />
            <Route path="/home/procedimientos" element={<PrivateRoute><Procedimientos /></PrivateRoute>} />
            <Route path="/home/admin/procedimientos" element={<AdminRoute><AdminProcedimientos /></AdminRoute>} />
            <Route path="/home/admin/usuarios" element={<AdminRoute><AdminUsuariosGestion /></AdminRoute>} />
            
            {/* Rutas de administrador - Todas bajo /administrador */}
            <Route path="/administrador" element={<AdminRoute><AdminLayout /></AdminRoute>}>
              <Route index element={<AdminInit />} />
              <Route path="dashboard-actividades" element={<ActivityDashboard />} />
              <Route path="dashboard-metricas" element={<ActivityDashboardMejorado />} />
              <Route path="descargas" element={<DownloadsReport />} />
              <Route path="administrar_usuarios" element={<AdminUsuarios />} />
              <Route path="reclamos" element={<ReclamosAdmin />} />
              <Route path="documentos" element={<AdminDocuments />} />
              <Route path="beneficios" element={<AdminBeneficios />} />
              <Route path="recibos" element={<CargaRecibos />} />
              <Route path="cargar-capacitaciones" element={<CargarCapacitaciones />} />
              <Route path="cargar-evaluacion" element={<CargarEvaluacion />} />
              <Route path="resumen-capacitaciones" element={<ResumenCapacitaciones />} />
              <Route path="imagenes" element={<DamageComparison />} />
              <Route path="talles" element={<TallesAdminView />} />
              <Route path="diagramas" element={<DiagramacionMensual />} />
              <Route path="diagramas-inspeccion" element={<SubirDiagrama usuario={user} />} />
              <Route path="admin-diagramas" element={<AdminDiagramas />} />
              {/* Rutas del módulo Flota */}
              <Route path="flota/resumen" element={<FlotaResumen />} />
              <Route path="flota/unidades" element={<FlotaUnidades />} />
              <Route path="flota/unidades/:interno" element={<FlotaDetalle />} />
              <Route path="flota/actividad" element={<FlotaActividad />} />
              <Route path="flota/alertas" element={<FlotaAlertas />} />
              {/* Políticas y Visión */}
              <Route path="politicas" element={<AdminPoliticas />} />
              {/* <Route path="ai-knowledge" element={<AdminAIKnowledge />} /> */}
            </Route>

            {/* Ruta 404 - Debe ir al final */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Router>
        
        {/* Widget de ayuda con IA - Solo para usuarios autenticados */}
        {/* {token && <HelpChatWidget />} */}
        
        {/* Botón flotante para cambiar empresa (DEMO) */}
        {/* <EmpresaSwitcher /> */}
        
        {/* Toast Container Global */}
        <ToastContainer
          position="top-center"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="colored"
        />
      </UserProvider>
    </ErrorBoundary>
  );
}

export default App;